import Page from '../page';

export default class HomepageIndex extends Page {
	constructor(...args) {
		super(...args);

		this._retrieveDOM();
		this._initTls();

		this._params = {
			height: window.innerHeight
		};
	}

	_retrieveDOM() {
		this.dom.header = this.dom.page.querySelector('.menu');
		this.dom.booking = this.dom.page.querySelectorAll('.js-program-booking');
		this.dom.popin = this.dom.page.querySelector('.js-video-popin');
		this.dom.popinVideo = this.dom.page.querySelector('.js-video');
		this.dom.popinOpenBtn = this.dom.page.querySelector('.js-open-video');
		this.dom.popinCloseBtn = this.dom.page.querySelector('.js-close-video');
		this.dom.programTitles = [].slice.call(this.dom.page.querySelectorAll('.js-program-title'));
		this.dom.programContents = this.dom.page.querySelectorAll('.js-program-content');
		this.dom.slider = this.dom.page.querySelector('.js-slider-container');
		this.dom.slides = [].slice.call(this.dom.page.querySelectorAll('.js-img-slider'));
		this.dom.sliderBtns = [].slice.call(this.dom.page.querySelectorAll('.js-button-slider'));
		this.dom.sliderDirection = [].slice.call(this.dom.page.querySelectorAll('.js-direction-slider'));
		this.dom.dancers = this.dom.page.querySelector('.js-popin-dancers');
		this.dom.dancersOpenBtn = this.dom.page.querySelector('.js-open-dancers');
		this.dom.dancersCloseBtn = this.dom.page.querySelector('.js-close-dancers');

		this._slideLength = this.dom.slides.length;
		this._currentSlide = 0;

	}

	bind() {
		//Open WeezEvent Iframe
		for( let i = 0; i < this.dom.booking.length ; i++) {
			this.dom.booking[i].addEventListener('click', this.openWeezEventIframe.bind(this));
		}
		//Open Video Popin
		this.dom.popinOpenBtn.addEventListener('click', this.openVideoPopin.bind(this));
		this.dom.popinCloseBtn.addEventListener('click', this.closeVideoPopin.bind(this));

		//Program Title Selection
		for( let i = 0; i < this.dom.programTitles.length ; i++) {
			this.dom.programTitles[i].addEventListener('click', (e) => {
				var el = e.currentTarget;
				if( el.classList.contains('active') )
					return;
				var index = this.dom.programTitles.indexOf(el);
				this.clearProgramActive();
				el.classList.add('active');
				this.dom.programContents[index].classList.add('active');

			});
		}

		//Slider Handler

		for( let i = 0; i < this.dom.sliderBtns.length ; i++) {
			this.dom.sliderBtns[i].addEventListener('click', (e) => {
				var el = e.currentTarget;
				if( el.classList.contains('active') )
					return;
				var index = this.dom.sliderBtns.indexOf(el);
				this.setActiveSlide(index);
			});
		}


		for( let i = 0; i < this.dom.sliderDirection.length ; i++) {
			this.dom.sliderDirection[i].addEventListener('click', (e) => {

				if(this.dom.sliderDirection[i].classList.contains('next')){
					var operator = 1;
				} else {
					var operator = -1;
				}
				var nextId = loopIndex(this._currentSlide + operator, this._slideLength);


				this.setActiveSlide(nextId);

			});
		}

		// Dancers Events
		this.dom.dancersOpenBtn.addEventListener('click', this._openPopinDancers.bind(this));
		this.dom.dancersCloseBtn.addEventListener('click', this._closePopinDancers.bind(this));

		//ScrollHandler
		window.addEventListener('scroll', this._scrollHandler.bind(this));

	}

	_openPopinDancers() {
		document.body.classList.add('no-scroll');
		TweenLite.to(this.dom.dancers, 0.5, {
			autoAlpha: 1
		});
	}

	_closePopinDancers() {
		document.body.classList.remove('no-scroll');
		TweenLite.to(this.dom.dancers, 0.5, {
			autoAlpha: 0
		});
	}

	clearProgramActive() {
		for( let i = 0; i < this.dom.programTitles.length ; i++) {
			this.dom.programTitles[i].classList.remove('active');
			this.dom.programContents[i].classList.remove('active');
		}
	}

	clearSliderActive() {
		for( let i = 0; i < this.dom.slides.length ; i++) {
			this.dom.slides[i].classList.remove('active');
			this.dom.sliderBtns[i].classList.remove('active');
		}
	}

	setActiveSlide(index) {
		this.clearSliderActive();
		this.dom.sliderBtns[index].classList.add('active');
		this.dom.sliderBtns[index].classList.add('active');
		this.dom.slides[index].classList.add('active');
		this._currentSlide = index;
	}

	openWeezEventIframe() {
		this.Components.Weezevent.openIframe();
	}

	openVideoPopin() {
		this.dom.popin.classList.add('show');
		this.dom.popinVideo.play();
	}

	closeVideoPopin() {
		this.dom.popin.classList.remove('show');
		this.dom.popinVideo.pause();
	}

	_scrollHandler() {
		if (this.getScroll() > this._params.height) {
			this.dom.header.classList.add('fixed');
		} else {
			this.dom.header.classList.remove('fixed');
		}
	}

	getScroll() {
		return (window.pageYOffset || document.documentElement.scrollTop) - (document.documentElement.clientTop || 0);
	}







	/**
	 * init() {}
	 * bind() {}
	 * unbind() {}
	 * resize(width, height) {}
	 * _destroy() {}
	 */
}



// WEBPACK FOOTER //
// ./src/js/pages/homepage/index.js